import React from 'react';
import { Surname as InnerField } from '@common/components/Account/components/Surname';
import { useAccountRules } from '@common/components/AccountMultiStep/rules/useAccountRules';
import { useTranslation } from '@common/hooks/useTranslation';
import { FieldWrapper } from '../FieldWrapper';

export const Surname = () => {
  const { t } = useTranslation();
  const { surnameRules } = useAccountRules();
  return (
    <FieldWrapper<string>
      name="surname"
      rules={surnameRules}
      render={(props) => {
        const mergedProps = { ...props, t };
        return <InnerField {...mergedProps} />;
      }}
    />
  );
};
